import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";
import { handleError } from "./ApiError";
import {
    GET_EVENTS,
    SG_GET_EVENTS,
    FETCH_EVENT,
    SG_FETCH_EVENT,
    UPDATE_EVENT,
    SG_UPDATE_EVENT,
    DELETE_EVENT,
    SG_DELETE_EVENT,
} from "constants/actions";

/* Events */

function* loadEvents(action) {
    try {
        const json = yield call(api.GET_APV2_EVENTS, action.payload);
        yield put({ type: GET_EVENTS, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* eventsLoad() {
    yield takeLatest(SG_GET_EVENTS, loadEvents);
}

function* fetchEvent(action) {
    try {
        const json = yield call(api.FETCH_APV2_EVENT, action.payload);
        yield put({ type: FETCH_EVENT, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* eventFetch() {
    yield takeLatest(SG_FETCH_EVENT, fetchEvent);
}

function* updateEvent(action) {
    try {
        const json = yield call(api.EDIT_APV2_EVENT, action.payload);
        yield put({ type: UPDATE_EVENT, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* eventUpdate() {
    yield takeLatest(SG_UPDATE_EVENT, updateEvent);
}

function* deleteEvent(action) {
    try {
        const json = yield call(api.DELETE_APV2_EVENT, action.payload);
        yield put({ type: DELETE_EVENT, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* eventDelete() {
    yield takeLatest(SG_DELETE_EVENT, deleteEvent);
}

export default function* index() {
    yield all([
        eventsLoad(),
        eventFetch(),
        eventUpdate(),
        eventDelete(),
    ]);
}
